import { ABOUT_DESI_COW_IMG } from '../../data/parasHomeData';
import { CheckCircleIcon } from './HomeIcons';

export default function AboutSection() {
  return (
    <section className="section about-section" id="about" aria-label="About Paras Organics">
      <div className="section-inner">
        <div className="about-grid">
          <div className="about-img-col">
            <div className="about-img-block tall">
              <img src={ABOUT_DESI_COW_IMG} alt="Paras Organics natural fertilizer production" className="about-block-image" />
            </div>
          </div>
          <div className="about-text">
            <span className="section-label" style={{ color: 'var(--gold-light)' }}>About Paras Organics</span>
            <h2 className="section-title white">Pure Organic Fertilizers</h2>
            <p className="section-desc" style={{ color: 'rgba(255,255,255,0.65)' }}>
              Based in Gandhinagar, Gujarat, Paras Organics is committed to producing qualitative, pure organic fertilizers using traditional wisdom and modern quality control. Our products are produced using only cow dung and earthworms - absolutely no chemicals, no artificial additives.
            </p>
            <div className="about-pillars">
              <div className="pillar">
                <span className="pillar-icon"><CheckCircleIcon className="ui-icon pillar-check-icon" /></span>
                <div className="pillar-text">
                  <h4>Zero Compromise on Purity</h4>
                  <p>No chemicals, no artificial additives. What goes into our products is exactly what nature provides.</p>
                </div>
              </div>
              <div className="pillar">
                <span className="pillar-icon"><CheckCircleIcon className="ui-icon pillar-check-icon" /></span>
                <div className="pillar-text">
                  <h4>FCO Government Standard Compliant</h4>
                  <p>Both products meet the Fertilizer Control Order standards set by the Government of India.</p>
                </div>
              </div>
              <div className="pillar">
                <span className="pillar-icon"><CheckCircleIcon className="ui-icon pillar-check-icon" /></span>
                <div className="pillar-text">
                  <h4>Supporting Indian Agriculture</h4>
                  <p>Our mission is to help Indian farmers and gardeners adopt sustainable, chemical-free practices.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
